export default __webpack_public_path__ + "static/media/template_pro__0006_21---Justin-Bonomo.30c277ce.png";